<script setup>
import "@/assets/main.css";
</script>

<template>
  <div class="not-found">
    <h3 class="text-3xl my-2 mt-16"><strong>404 Not Found</strong></h3>
    <p>Halaman yang Anda cari tidak ditemukan.</p>
  </div>
</template>
<style scoped>
.not-found {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100vh;
  text-align: center;
  background-color: #1a1a1a;
  color: #f9de58;
}
</style>
